import AspectIcons from './AspectIcons'

export default AspectIcons
